/// Create By PRATAN : 2023-05-01

import React from "react";
import ConfigETC from "../Class/ConfigETC.json";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

function Timeoff_View({ list, index, Onclick_EditTimeoff, Onclick_DeleteTimeoff,permissionEdit,permissionDel }) {
  return (

<TableRow>
      <TableCell><div>{index}<input type="hidden" id="hd_iddel" defaultValue={list.timeoff_id}></input></div></TableCell>
      <TableCell align="left"><div>{list.timeoff_name}</div></TableCell>
      <TableCell align="left"><div className="text-sm">{list.timeoff_desc}</div></TableCell>
      <TableCell align="left"><div>{list.timeoff_type_str}</div></TableCell>
      <TableCell align="left">
        <div>
          <span
            className={
              list.timeoff_status === 1
                ? ConfigETC.Status_active
                : ConfigETC.Status_inactive
            }
          >
            {list.timeoff_status_str}
          </span>
        </div>
      </TableCell>
      <TableCell align="left">
      <div className="btn-group btn-group-sm">
          {(permissionEdit === true) &&
              <a
                href="#!"
                className="btn btn-primary btn-sm"
                onClick={(event) => Onclick_EditTimeoff(event, list)}
              > <i className="fas fa-pencil-alt" />
              </a>
           }
           {(permissionDel === true) &&
              <a
                href="#!" className="btn btn-default btn-sm"
                onClick={() => Onclick_DeleteTimeoff(list.timeoff_id)}
              > <i className="fas fa-trash" />
              </a>
          }
           </div>
      </TableCell>
    </TableRow>


  );
};

export default Timeoff_View;
